var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M212.108 168.806C136.695 179.327 168.29 266.184 189.486 313.081C214.366 368.129 192.572 405.037 192.572 405.037L76.0002 363.649C118.784 309.239 71.5342 278.937 83.1662 214.063C93.6002 155.869 150.236 129.613 186.02 130.851C203.882 131.469 218.5 136.069 230.072 141.967C230.512 142.191 230.932 142.431 231.332 142.685C252.472 120.976 281.735 108.001 315.554 108.001C385.104 108.001 447.592 162.875 447.592 235.737C447.592 308.599 391.212 367.665 321.66 367.665C252.11 367.665 195.728 308.599 195.728 235.737C195.728 210.835 201.601 188.034 212.108 168.806Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.963 371.149C333.963 371.149 308.101 371.913 297.079 365.893L332.589 388.187L333.963 371.149Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M430.373 273.677C426.495 303.684 416.436 345.965 391.598 362.482C378.418 371.242 354.418 372.322 333.958 371.142L329.278 429.242L262.518 401.762C262.518 401.762 268.938 337.642 271.72 313.062C258.3 300.902 235.438 295.262 235.398 274.602C235.398 267.442 239.578 255.062 255.018 255.022C275.738 255.002 272.778 279.842 272.778 279.842C275.345 280.839 277.919 280.781 280.486 279.865C301.002 279.013 358.068 270.422 396.867 204.124C401.395 226.44 410.807 254.257 430.373 273.677Z",
    fill: "#ED4848"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.182 279.788L404.982 315.668L387.812 315.324L390.182 279.788Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.424 281.344C374.056 288.512 369.84 294.096 365.008 293.818C360.178 293.54 356.558 287.504 356.928 280.336C357.298 273.168 361.512 267.584 366.344 267.862C371.176 268.14 374.794 274.178 374.424 281.344Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.799 280.199C419.429 287.367 415.215 292.951 410.383 292.673C405.551 292.395 401.933 286.359 402.301 279.191C402.671 272.023 406.885 266.437 411.717 266.715C416.549 266.993 420.167 273.031 419.799 280.199Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M383.6 332.509C383.6 332.509 372.412 336.121 361.2 323.655",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    opacity: 0.402786,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.92 371.149C333.92 371.149 308.06 371.913 297.036 365.891L332.546 388.185L333.92 371.149Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead3);
export default __webpack_public_path__ + "static/media/Girl-Head-3.13717cd0.svg";
export { ForwardRef as ReactComponent };